<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <h1 class="title">Client’s Arrivals</h1>
      </app-cells>
      <div v-for="table_item of table.items" :key="table_item.name" class="table-block">
        <app-cells v-if="table_item.name">
          <h2 class="title">{{ table_item.name }}</h2>
          <div v-if="table_item.today" class="status-title" :style="{ 'backgroundColor': '#77b017' }">Today</div>
        </app-cells>
        <v-client-table
          :data="table_item.items"
          :columns="table.columns"
          :options="table.options"
          class="table-default"
        >
          <template #h__group><div class="table-default__left">Group</div></template>
          <template #group="{ row }">
            <div class="table-default__controls table-default__left">
              <button @click="onOpenPrintPopup(row)" type="button">
                <img src="@/assets/img/print-table-icon.svg" alt="">
              </button>
              {{ row.name }} ({{ row.pax }})
            </div>
          </template>
          <template #pick_up="{ row }">
            {{ row.pick_up_point.short_name }} at {{ row.pick_up_time }}
          </template>
          <template #drop_off="{ row }">
            {{ row.points.at(-1).location.short_name }}
          </template>
        </v-client-table>
      </div>
    </template>
    <modal
      name="print-form"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('print-form')" class="popup__close" type="button"></button>
        <div class="popup__title">Print welcome documents</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckPrintForm">
            <app-form-group label="Signboard" label-for="signboard" required>
              <app-textarea
                v-model="print_form.signboard"
                rows="5"
                placeholder="Write a signboard"
                id="signboard"
                :error="$v.print_form.signboard.$error"
              />
              <template #error>
                <div v-if="$v.print_form.signboard.$dirty && !$v.print_form.signboard.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="print_form" :disabled="$v.print_form.$error">Print</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { getTransfersArrivalsDatesList, postTransfersWLExport } from '@/http'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'ClientsArrivalsList',
  data() {
    return {
      is_loaded: false,
      table: {
        items: [],
        columns: ['group', 'pick_up', 'drop_off'],
        options: {
          headings: {
            group: 'Group',
            pick_up: 'Pick-up',
            drop_off: 'Drop-off',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      print_form: {},
    }
  },
  validations: {
    print_form: {
      signboard: { required },
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    onOpenPrintPopup(row) {
      this.print_form = { ...row }
      this.$v.print_form.$reset()
      this.$modal.show('print-form')
    },
    onCheckPrintForm() {
      this.$v.print_form.$touch()
      if (this.$v.print_form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.print_form.preload = true
      postTransfersWLExport(this.print_form.id, { signboard: this.print_form.signboard })
        .finally(() => { this.$refs.print_form.preload = false })
        .then(response => {
          this.$modal.hide('print-form')
          window.open(response.data)
        })
    },
    fetchItems() {
      this.is_loaded = false
      getTransfersArrivalsDatesList({ group_by: 'pick_up_date', range_type: 'day' })
        .then(res => {
          this.table.items = res.data
          this.is_loaded = true
        })
    }
  }
}
</script>

<style lang="sass" scoped>
.table-block
  margin-bottom: 30px

  &:last-child
    margin-bottom: 0
</style>
